"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _api = require("../api/api");
var _login = _interopRequireDefault(require("./loginreg/login"));
var _cookie = require("@/assets/static/js/utils/cookie.js");
var _elementUi = require("element-ui");
var _sideNav = _interopRequireDefault(require("@/components/side-nav.vue"));
var _topNav = _interopRequireDefault(require("@/components/top-nav.vue"));
var _default = exports.default = {
  inject: ['reload'],
  name: 'mainlayout',
  components: {
    Login: _login.default,
    sideNav: _sideNav.default,
    topNav: _topNav.default
  },
  data: function data() {
    return {
      routerViewId: 'mainlayout_content',
      boxshow: true,
      isEntered: true,
      activeIndex: '1',
      //登录状态菜单
      tabName: ''
    };
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // session替换成cookie
            this.$root.isLogin = (0, _cookie.getCookie)('user') ? true : false;
            this.isEntered = window.localStorage.getItem('isEntered') ? false : true;
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  mounted: function mounted() {
    // console.log('ref',this.$refs['router-body'])
    var that = this;
    window.localStorage.setItem('isEntered', true);
    that.boxshow = !that.boxshow;
    setTimeout(function () {
      that.$root.adHeight = false;
    }, 5250);
  },
  methods: {
    // 登录注册弹窗的关闭事件
    loginStatus: function loginStatus(val) {
      this.$root.isLogin = val;
    },
    // 复制推广Url到剪切板
    toCopyUrl: function toCopyUrl(url) {
      var _this = this;
      this.$copyText(url).then(function (res) {
        _this.$message({
          message: '已成功复制，可直接去粘贴！',
          type: 'success'
        });
      }, function (err) {
        _this.$message({
          message: '复制失败！',
          type: 'error'
        });
      });
    }
  }
};